import {
  FaCheckCircle,
  FaGrimace,
  FaExclamationTriangle,
} from 'react-icons/fa';
import styled, { css } from 'styled-components'

const iconStyles = css`
  font-size: 3rem;
  margin-right: 0.8rem;
`;

export const Button = styled.button`
  border: unset;
  margin-left: 0.8rem;
  cursor: pointer;
  color: #9e9e9e;
  background-color: white;
`

export const Container = styled.div`
  padding: 0.8rem;
  background-color: white;
  -webkit-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.25);
  -moz-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.25);
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.25);
`

export const CheckIcon = styled(FaCheckCircle)`
  color: #22b884;
  ${iconStyles};
`;

export const Grimace = styled(FaGrimace)`
  color: #d32f2f;
  ${iconStyles};
`;

export const ExclamationTriangle = styled(FaExclamationTriangle)`
  color: #FC7C26;
  ${iconStyles};
`;